var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import styles from './CustomMarker-hashed.scss';

export default function (mapsApi) {
    var CustomMarker = function (_mapsApi$OverlayView) {
        _inherits(CustomMarker, _mapsApi$OverlayView);

        function CustomMarker(latlng, map, options) {
            _classCallCheck(this, CustomMarker);

            var _this = _possibleConstructorReturn(this, (CustomMarker.__proto__ || Object.getPrototypeOf(CustomMarker)).call(this));

            _this.latlng = latlng;
            _this.options = options || {};
            _this.setMap(map);
            _this.mapsApi = mapsApi;
            return _this;
        }

        _createClass(CustomMarker, [{
            key: 'draw',
            value: function draw() {
                var _this2 = this;

                if (!this.div) {
                    this.div = document.createElement('div');
                    this.div.className = styles.marker;
                    this.div.style.background = this.options.backgroundColor;
                    this.div.innerHTML = '<i data-id="' + this.options.id + '" class="fa ' + styles.icon + ' fa-' + this.options.icon + '"/>';

                    this.mapsApi.event.addDomListener(this.div, 'click', function (event) {
                        _this2.mapsApi.event.trigger(_this2, 'click', event);
                    });

                    this.mapsApi.event.addDomListener(this.div, 'mouseover', function (event) {
                        _this2.mapsApi.event.trigger(_this2, 'mouseover', event);
                    });

                    this.mapsApi.event.addDomListener(this.div, 'mouseout', function (event) {
                        _this2.mapsApi.event.trigger(_this2, 'mouseout', event);
                    });

                    this.getPanes().overlayImage.appendChild(this.div);
                }

                var point = this.getProjection().fromLatLngToDivPixel(this.latlng);

                if (point) {
                    this.div.style.left = point.x + 'px';
                    this.div.style.top = point.y + 'px';
                }
            }
        }, {
            key: 'remove',
            value: function remove() {
                if (this.div) {
                    this.div.parentNode.removeChild(this.div);
                    delete this.div;
                }
            }
        }, {
            key: 'getPosition',
            value: function getPosition() {
                return this.latlng;
            }
        }]);

        return CustomMarker;
    }(mapsApi.OverlayView);

    return CustomMarker;
}


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/pa/components/RepairFacilitiesMap/CustomMarker/CustomMarkerFactory.js
// module id = 1563
// module chunks = 0